import { getConciliationAmountLimit } from '../../../../../../utils/conciliationAmountLimit'
import { useContext, useEffect, useState } from 'react'
import LoaderAdm from '../../../../../../../assets/svgIcons/LoaderAdm.json'
import Lottie from 'lottie-react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import clsx from 'clsx'
import TableConciliar from './TableConciliar'
import GlobalContext from '../../../../../../../context/global-context'
import dayjs from 'dayjs'
import FilterDateConciliar from '../../../../../table/FilterDateConciliar'
import { OrganizationAPI } from '../../../../../../../api/organization.api'
import { BankAPI } from '../../../../../../../api/bancos.api'
import TableCajaPrincipal from './TableCajaPrincipal'

const InputField = ({ label, placeholder, type, value, onChange }) => (
  <div className='mt-1'>
    <label className="block mb-[1px] text-[11px] font-sans font-medium text-gray-700 leading-tight">{label}</label>
    <input
    type={type}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className=' h-7 block w-[150px] rounded-full border-gray-300 sm:text-[11px] font-sans font-medium'
    />
  </div>
)

const ListRemuneracion = ({idLibro,
  dataModal,
  setInitialSelectedIds,
  onCurrentDataBanco,
  onCurrentDataCaja,
  selectedBank,
  setSelectedBank,
  dataLinkage,
  dataLinkagePre,
  tipoLibro,
  selectedIds,
  setSelectedIds,
  useCajaPrincipal,
  setUseCajaPrincipal,
  unselectedIds,
  setUnselectedIds,
  origenSeleccionado,
  setOrigenSeleccionado,
  setUserInteracted,
  selectedCheckboxes,
  setSelectedCheckboxes,
  selectedDataByOrigen,
  setSelectedDataByOrigen,
  reconciliationDetail
 }) => {
  const [showFilters, setShowFilters] = useState(true)
  const [data, setData] = useState([])
  const { currentBusiness } = useContext(GlobalContext)
  const organizationAPI = new OrganizationAPI()
  const [, setMonthFilter] = useState(dayjs().format('MM'))
  const [, setYearFilter] = useState(dayjs().format('YYYY'))
  const [filters] = useState({
    fechaInicio: dayjs().startOf('year').format('YYYY-MM-DD'),
    fechaFin: dayjs().format('YYYY-MM-DD'),
  })
  const [tempFilters, setTempFilters] = useState({ ...filters })
  const [searchKeyword, setSearchKeyword] = useState('')
  const [valoresAprox, setValoresAprox] = useState(false)
  const [dataBanco, setDataBanco] = useState({})
  const [porcentajeRange] = useState([0, 100])
  const bankAPI = new BankAPI()
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [page] = useState(0)
  const [rowsPerPage] = useState(-1)
  const toArr = v => (Array.isArray(v) ? v : [])
  // FIFO de filas seleccionadas
  const [, setSelectionQueue] = useState([])

  // Acordeón: estado y helpers (ponlo cerca de otros useState)
  const [collapsed, setCollapsed] = useState({})

  // ¿está colapsada esta sección?
  const isCollapsed = key => Boolean(collapsed?.[key])

  // alternar colapso/expansión
  const toggleSection = key => setCollapsed(prev => ({ ...prev, [key]: !prev?.[key] }))
  // Derivados seguros
  const safeSelectedIds = toArr(selectedIds)
  const safeOrigen = toArr(origenSeleccionado)

  const opciones = [
      { value: 'caja', label: 'Pago con Caja principal' },
      { value: 'banco', label: 'Bancos' }
    ]

  const [order, setOrder] = useState({
    col: '',
    field: '',
    direction: 'asc'
  })

  const getBanco = async () => {
    try {
      const responseBank = await bankAPI.getListBank(currentBusiness.id) 
      setDataBanco(responseBank)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getBanco()
  }, [currentBusiness])

  const bankOptions = [
    'Caja Principal',
    ...(Array.isArray(dataBanco?.data)
      ? dataBanco.data
          .map((item) => item.bank?.name)
          .filter((name) => name && name !== 'Caja Principal')
          .filter((value, index, self) => self.indexOf(value) === index)
      : []),
  ]

  useEffect(() => {
    setSelectionQueue(prev => {
      const keep = prev.filter(id => safeSelectedIds.includes(id))
      const additions = safeSelectedIds.filter(id => !prev.includes(id))
      return [...keep, ...additions]
    })
  }, [selectedIds])

  const handleCheckboxChange = (tipo, ids) => {
    // ids siempre es array de números
    const idsArr = toArr(ids).filter(id => Number.isFinite(Number(id)))

    setSelectedIds(prev => ({
      ...prev,
      [tipo]: idsArr
    }))

    setSelectionQueue(prev => {
      const keep = prev.filter(id => idsArr.includes(id))
      const additions = idsArr.filter(id => !prev.includes(id))
      return [...keep, ...additions]
    })
  }

  const functionGetData = async () => {
    try {
      const response = await organizationAPI.getListaParaVincular({
        businessId: currentBusiness.id, 
        idLibro: idLibro,
        from: tempFilters.fechaInicio,
        to: tempFilters.fechaFin,
        amountFrom: 1,
        amountTo: getConciliationAmountLimit(tipoLibro === 'previred' ? dataModal?.montoNeto : dataModal?.montoTotal),
        limit: 10000,
      })
      setData(response.data.libros || [])
       setIsLoadingData(false)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (idLibro) {
      functionGetData()
    }
  }, [idLibro, tempFilters, dataModal?.montoTotal, dataModal?.montoNeto, tipoLibro])

  const handleDateChange = (key, newValue) => {
    const newDate = dayjs(newValue)
    setTempFilters((prev) => ({
      ...prev,
      [key]: newDate.format('YYYY-MM-DD'),
    }))
    if (key === 'fechaInicio') {
      setMonthFilter(newDate.format('MM'))
      setYearFilter(newDate.format('YYYY'))
    }
  }

const linkage =
  tipoLibro === 'previred' ? dataModal?.linkagePrevired : dataModal?.linkage

const e2eRemuneracionIdLibros = Array.isArray(reconciliationDetail?.movements)
  ? reconciliationDetail.movements
    .map(movement => movement?.idLibro)
    .filter(id => id != null)
  : []

const effectiveLinkage = [
  ...(Array.isArray(linkage) ? linkage : []),
  ...e2eRemuneracionIdLibros.map(idLibro => ({
    idPrincipal: idLibro,
    __e2eRemuneracion: true
  }))
]

const getLinkageKeys = item =>
  [item?.comprobante, item?.id, item?.idPrincipal]
    .filter(value => value != null && String(value).trim() !== '')
    .map(value => String(value).trim())

const normalizeRemuneracionStatus = status =>
  String(status || '')
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s*UNDEFINED\s*/g, ' ')
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

const getRemuneracionStatusKey = status => {
  const normalized = normalizeRemuneracionStatus(status)
  if (!normalized) return 'OTHER'
  if (normalized.includes('PARCIALMENTE PAGADO')) return 'PARCIALMENTE_PAGADO'
  if (normalized.includes('POR PAG')) return 'POR_PAGAR'
  if (normalized.includes('PAGADO')) return 'PAGADO'
  return 'OTHER'
}

const rawModalStatus = (
  tipoLibro === 'previred' ? dataModal?.statusPrevired : dataModal?.status
) ?? ''

const modalStatus = normalizeRemuneracionStatus(rawModalStatus)
const modalStatusKey = getRemuneracionStatusKey(rawModalStatus)

const isPartialConciliation = modalStatusKey === 'PARCIALMENTE_PAGADO'
const isPendingStatus = modalStatusKey === 'POR_PAGAR'

const getRowStatus = (row) =>
  normalizeRemuneracionStatus(
    tipoLibro === 'previred'
      ? row.statusPrevired ?? row.status
      : row.status
  )

const calcPorcentaje = (monto, total) => {
  const montoNum = Math.abs(Number(monto))
  if (isNaN(montoNum) || total === 0) return 0
  const diff = Math.abs(montoNum - total)
  return Math.max((1 - diff / total) * 100, 0)
}

const total = Number(
  tipoLibro === 'previred' ? dataModal?.montoNeto : dataModal?.montoTotal
) || 1

const enrichAndFilter = (row) => {
  const monto = row.montoTotal ?? (row.montoAbono || row.montoCargo)
  const porcentaje = calcPorcentaje(monto, total)
  return { ...row, porcentaje }
}

const applyFilters = (rows) =>
  rows
    .map(enrichAndFilter)
    .filter((item) => {
      const matchesKeyword = item.descripcion
        ?.toLowerCase()
        ?.includes(searchKeyword.toLowerCase())
      const matchesBank = selectedBank
        ? item.nombreCuentaBanco?.trim().toLowerCase() ===
          selectedBank.toLowerCase()
        : true
      const matchesPorcentaje =
        item.porcentaje >= porcentajeRange[0] &&
        item.porcentaje <= porcentajeRange[1]

      return matchesKeyword && matchesBank && matchesPorcentaje
    })

  const linkageSet = new Set(
    effectiveLinkage.flatMap(getLinkageKeys)
  )

  const isLinkedRow = (row) => {
    return getLinkageKeys(row).some(key => linkageSet.has(key))
  }

  const matchesValidStatus = (row) => {
    const status = getRowStatus(row)
    return (
      status.includes('POR PAGAR') ||
      status.includes('PENDIENTE') ||
      status.includes('PARCIALMENTE PAGADO') ||
      status.includes('PARCIALMENTE CONCILIADO')
    )
  }

  let filteredRows = []

  const sourceRows = Array.isArray(data) ? [...data] : []
  const bankLinkageRows = (Array.isArray(linkage) ? linkage : []).filter(item =>
    [item?.tabla, item?.tablaPrincipal, item?.origenTabla, item?.libroContableOriginTableId]
      .some(value => [6, 7].includes(Number(value)))
  )

  bankLinkageRows.forEach(linkageItem => {
    const linkageComprobante = String(linkageItem?.comprobante ?? '').trim()
    const linkageIds = [linkageItem?.id, linkageItem?.idPrincipal]
      .filter(id => id != null)
      .map(String)
    const alreadyPresent = sourceRows.some(item => {
      const comprobante = String(item?.comprobante ?? '').trim()
      const itemIds = [item?.id, item?.idPrincipal].filter(id => id != null).map(String)
      return (
        (linkageComprobante && comprobante === linkageComprobante) ||
        itemIds.some(id => linkageIds.includes(id))
      )
    })

    if (!alreadyPresent) {
      sourceRows.push({
        ...linkageItem,
        id: linkageItem?.id ?? linkageItem?.idPrincipal,
        seleccionado: true
      })
    }
  })

  const allFilteredRows = applyFilters(sourceRows)

  if (linkageSet.size === 0) {
    filteredRows = allFilteredRows
  }
  else if (modalStatusKey === 'PAGADO' || isPartialConciliation || isPendingStatus) {
    filteredRows = allFilteredRows.filter(row => isLinkedRow(row) || matchesValidStatus(row))
  }
  else {
    filteredRows = allFilteredRows
  }

  const linkedRows = filteredRows.filter(isLinkedRow)
  const unlinkedRows = filteredRows.filter(row => !isLinkedRow(row))
  if (valoresAprox) {
    unlinkedRows.sort((a, b) => b.porcentaje - a.porcentaje)
  }

  filteredRows = [...linkedRows, ...unlinkedRows]
  filteredRows = filteredRows.map(row => ({
    ...row,
    seleccionado: isLinkedRow(row)
  }))

  const handleSort = ({ col, field }) => {
    const isAsc = order.col === col && order.direction === 'asc'
    setOrder({ col, field, direction: isAsc ? 'desc' : 'asc' })
  }

  const getSortValue = (row, field) => {
    if (field === 'fecha') return dayjs(row?.fecha).valueOf()
    if (field === 'cuentaCorriente') {
      return `${row?.nombreCuentaBanco ?? ''} ${row?.numeroCuentaBanco ?? ''}`
    }
    if (field === 'descripcion') return row?.descripcion ?? ''
    if (field === 'abono') return Number(row?.montoAbono) || 0
    if (field === 'cargo') return Number(row?.montoTotal ?? row?.montoCargo) || 0
    if (field === 'status') return getRowStatus(row)
    return row?.[field] ?? ''
  }

  const sortedRows = order.field
    ? filteredRows
        .map((row, index) => ({ row, index }))
        .sort((a, b) => {
          const valueA = getSortValue(a.row, order.field)
          const valueB = getSortValue(b.row, order.field)
          const comparison =
            typeof valueA === 'number' && typeof valueB === 'number'
              ? valueA - valueB
              : String(valueA).localeCompare(String(valueB), 'es', {
                  numeric: true,
                  sensitivity: 'base'
                })
          return (comparison || a.index - b.index) * (order.direction === 'asc' ? 1 : -1)
        })
        .map(({ row }) => row)
    : filteredRows

  const paginatedData = rowsPerPage > 0
    ? sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : sortedRows

  const isSelectedView = val => safeOrigen.includes(val)
  
  const orderedSections = []
  safeOrigen.forEach(v => {
    if (v === 'banco') orderedSections.push('banco')
    else if (v === 'caja') orderedSections.push('caja')
  })

  const getSectionSelectedCount = key => {
    if (key === 'banco') return toArr(selectedDataByOrigen?.banco).length
    if (key === 'caja') return toArr(selectedDataByOrigen?.caja).length
    return 0
  }

  const renderSection = key => {
    const baseTitle =
      key === 'banco'
        ? 'Movimientos Bancarios'
        : key === 'caja'
          ? 'Movimientos de Caja'
            : ''

    const selectedCount = getSectionSelectedCount(key)
    const headerTitle = selectedCount > 0 ? `${baseTitle} (${selectedCount})` : baseTitle

    if (key === 'banco' && !isSelectedView('banco')) return null
    if (key === 'caja' && !isSelectedView('caja')) return null

    return (
      <div key={`sec-${key}`} className='border border-gray-200 rounded-3xl bg-gray-100'>
        <button
          type='button'
          onClick={() => toggleSection(key)}
          className='w-full flex items-center justify-between px-3 py-2'
          aria-expanded={!isCollapsed(key)}
          aria-controls={`sec-panel-${key}`}
        >
          <span className='text-sm font-medium'>{headerTitle}</span>
          <KeyboardArrowDownIcon
            className={clsx('transition-transform', { 'rotate-180': !isCollapsed(key) })}
          />
        </button>

        {/* Contenido colapsable */}
        <div
          id={`sec-panel-${key}`}
          className={clsx(
            'transition-[max-height] duration-300 ease-in-out overflow-hidden',
            isCollapsed(key) ? 'max-h-0' : 'flex-1 h-full'
          )}
        >
          <div className='p-3 pt-0'>
            {key === 'banco' && (
              <TableConciliar
                rows={paginatedData}
                idLibro={idLibro}
                dataModal={dataModal}
                reconciliationDetail={reconciliationDetail}
                selectedBankFilter={selectedBank}
                setInitialSelectedIds={setInitialSelectedIds}
                //onCheckboxChange={ids => handleCheckboxChange('caja', ids)}
                onCheckboxChange={ids => handleCheckboxChange('banco', ids)}
                onCurrentData={onCurrentDataBanco}
                dataLinkagePre={
                  tipoLibro === 'previred'
                    ? effectiveLinkage
                    : dataLinkagePre
                }
                dataLinkage={
                  tipoLibro === 'liquido'
                    ? effectiveLinkage
                    : dataLinkage
                }
                tipoLibro={tipoLibro}
                onSort={handleSort}
                order={order}
                selectedIds={selectedIds.banco}
                setSelectedIds={ids => setSelectedIds(prev => ({ ...prev, banco: ids }))}
                unselectedIds={unselectedIds.banco}
                setUnselectedIds={updater => {
                  setUnselectedIds(prev => ({
                    ...prev,
                    banco: typeof updater === 'function' ? updater(prev.banco) : updater
                  }))
                }}
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={setSelectedCheckboxes}
              />
            )}

            {key === 'caja' && (
              <TableCajaPrincipal
                onCheckboxChange={handleCheckboxChange}
                rows={filteredRows}
                dataModal={dataModal}
                selectedBankFilter={selectedBank}
                useCajaPrincipal={true}
                modalStatus={modalStatus}
                onCurrentData={onCurrentDataCaja}
                dataLinkagePre={dataLinkagePre}
                dataLinkage={dataLinkage}
                tipoLibro={tipoLibro}
                selectedIds={selectedIds.caja}
                setSelectedIds={ids => setSelectedIds(prev => ({ ...prev, caja: ids }))}
                unselectedIds={unselectedIds.caja}
                setUnselectedIds={updater => {
                  setUnselectedIds(prev => ({
                    ...prev,
                    caja: typeof updater === 'function' ? updater(prev.caja) : updater
                  }))
                }}
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={setSelectedCheckboxes}
                selectedDataByOrigen={selectedDataByOrigen}
                setSelectedDataByOrigen={setSelectedDataByOrigen}
              />
            )}

          </div>
        </div>
      </div>
    )
  }

  useEffect(() => {
    const linkedRows = Array.isArray(linkage) ? linkage : []
    if (linkedRows.length === 0) {
      setOrigenSeleccionado(['banco'])
      return
    }

    const isCajaPrincipal = item =>
      [item?.nombreCuentaBanco, item?.nombreBanco, item?.name]
        .some(value => String(value ?? '').trim().toLowerCase() === 'caja principal')

    const origenes = []
    if (linkedRows.some(item => !isCajaPrincipal(item))) origenes.push('banco')
    if (linkedRows.some(isCajaPrincipal)) origenes.push('caja')

    setOrigenSeleccionado(origenes.length > 0 ? origenes : ['banco'])
  }, [linkage])

   useEffect(() => {
      if (safeOrigen.length === 0) return
      const ultimo = safeOrigen[safeOrigen.length - 1]
      const mapKey = origen => {
        if (origen === 'banco') return 'banco'
        if (origen === 'caja') return 'caja'
        return null
      }
      const ultimaKey = mapKey(ultimo)
      if (!ultimaKey) return
      setCollapsed(prev => {
        const next = { ...prev }
        ;['banco', 'caja'].forEach(k => {
          next[k] = k !== ultimaKey // true = colapsado
        })
        return next
      })
    }, [safeOrigen])

  return ( 
    <div className="h-full p-3 bg-white rounded-3xl shadow-md flex flex-col overflow-hidden"> 
    {isLoadingData ? (
        <div className='flex items-center justify-center h-64'>
          <Lottie animationData={LoaderAdm} loop style={{ width: 200, height: 200 }} />
        </div>
      ) : (
      <>
      <div className='border border-gray-200 rounded-3xl p-4 bg-gray-50'>
        <div className='flex flex-wrap gap-x-2 gap-y-4 items-start'>
          <div className='flex flex-wrap gap-x-2 gap-y-4 items-start flex-1'>
            <div className='min-w-[150px] flex flex-col justify-end mt-5 font-sans font-medium'>
            <FilterDateConciliar
              label="Fecha Desde"
              value={tempFilters.fechaInicio}
              onChange={(newValue) => handleDateChange("fechaInicio", newValue)}
            />
          </div>
          <div className="min-w-[150px] flex flex-col justify-end mt-5 font-sans font-medium">
            <FilterDateConciliar
              label="Fecha Hasta"
              value={tempFilters.fechaFin}
              onChange={(newValue) => handleDateChange("fechaFin", newValue)}
            />
          </div>
          <div className="min-w-[150px] font-sans font-medium">
            <InputField
              label="Palabra Clave"
              type="text"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
          </div>
          <div className="min-w-[150px]">
            <label className="block mb-[1px] mt-1 text-[11px] font-sans font-medium text-gray-700 leading-tight">Bancos</label>
            <select
              className="h-7 w-full appearance-none focus:outline-none border border-gray-300 px-4 py-[3px] rounded-full leading-tight text-[11px]"
              onChange={(e) => setSelectedBank(e.target.value)}
              value={selectedBank}
            >
              <option value="">Todos</option>
              {bankOptions
                  .filter((bankName) => bankName !== 'Caja Principal')
                  .map((bankName) => (
                    <option key={bankName} value={bankName}>
                      {bankName}
                    </option>
                ))}
            </select>
          </div>
          <label className='mt-5 inline-flex h-7 cursor-pointer items-center gap-2 text-[11px] font-sans font-medium'>
            <input
              type='checkbox'
              checked={valoresAprox}
              onChange={e => setValoresAprox(e.target.checked)}
              className='rounded'
            />
            Monto Similares
          </label>
        {showFilters && (
          <div id='filters-panel' className='contents'>
          {/*<div className="min-w-[150px] flex flex-col">
              <label className=" text-[11px] font-medium text-gray-700 leading-tight">Coincidencia Porcentaje</label>
              <Slider
                value={porcentajeRange}
                onChange={(e, newValue) => setPorcentajeRange(newValue)}
                valueLabelDisplay="auto"
                valueLabelFormat={(value) => `${value}%`}
                min={0}
                max={100}
                sx={{
                  height: 4,
                  '& .MuiSlider-thumb': {
                    width: 14,
                    height: 14,
                  },
                  '& .MuiSlider-track': {
                    height: 4,
                  },
                  '& .MuiSlider-rail': {
                    height: 4,
                  },
                  '& .MuiSlider-valueLabel': {
                    fontSize: '10px',
                    padding: '2px 4px',
                  },
                }}
              />
              <div className="text-[11px] text-gray-600 mt-1">
                {porcentajeRange[0]}% - {porcentajeRange[1]}%
              </div>
            </div>*/}
            <div className='min-w-[200px]'>
              <label className='block mb-[1px] mt-1 text-[11px] font-sans font-medium text-gray-700 leading-tight'>
                Tipo de Pago
              </label>
              <div className='grid grid-cols-2 gap-x-4 gap-y-2 px-3 py-2 text-[11px]'>
              {opciones.map(option => (
                <label key={option.value} className='flex items-center gap-2 font-sans font-medium'>
                  <input
                    type='checkbox'
                    className='rounded'
                    value={option.value}
                    checked={origenSeleccionado.includes(option.value)}
                    onChange={e => {
                      const checked = e.target.checked
                      const origen = option.value
                      setOrigenSeleccionado(prev => {
                        const updated = checked
                          ? [...prev, origen]
                          : prev.filter(val => val !== origen)
                        return updated
                      })
                      if (!checked) {
                        const idsToRemove = (selectedDataByOrigen[origen] || []).map(r => r.id)
                        setUnselectedIds(prev => ({
                          ...prev,
                          [origen]: idsToRemove
                        }))
                        setSelectedDataByOrigen(prev => {
                          const next = { ...prev }
                          delete next[origen]
                          return next
                        })
                        setSelectedIds(prev => {
                          const next = { ...prev }
                          delete next[origen]
                          return next
                        })
                        setSelectedCheckboxes(prev => {
                          const next = { ...prev }
                          idsToRemove.forEach(id => delete next[id])
                          return next
                        })
                      } else {
                        setUnselectedIds(prev => {
                          const next = { ...prev }
                          delete next[origen]
                          return next
                        })
                      }
                    }}
                  />
                  {option.label}
                </label>
              ))}
            </div>
            </div>
          </div>
        )}
        </div>
          <div className='ml-auto mt-5'>
            <button
              type='button'
              className='flex items-center px-1 py-0.5 bg-gray-200 rounded hover:bg-gray-300 transition'
              onClick={() => setShowFilters(prev => !prev)}
              aria-expanded={showFilters}
              aria-controls='filters-panel'
            >
              <KeyboardArrowDownIcon
                className={clsx('transition-transform', { 'rotate-180': showFilters })}
              />
            </button>
          </div>
        </div>
      </div>
      <div className='flex-1 min-h-0 mt-3 overflow-y-auto overflow-x-hidden'>
        <div className='flex flex-col space-y-3'>
          {orderedSections.map(secKey => renderSection(secKey))}
        </div>
      </div>
      </>
      )}
    </div>
  )
}

export default ListRemuneracion
